import React from 'react';
import NoticeWindow from '../components/NoticeWindow';
import AppHeader from '../components/AppHeader';
import NavBar from '../components/NavBar';
import localize from '../components/localize';

const NotFound = localize('errors.notFound')(NoticeWindow);

export default () => (
  <div>
    <AppHeader>
      <NavBar />
    </AppHeader>
    <div>
    	<NotFound />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/NotFound.js